export default __webpack_public_path__ + "static/media/new_logo_simba.7dab8c27.svg";